import { render, staticRenderFns } from "./MetroidvaniaDescript.vue?vue&type=template&id=40dc1fcf"
import script from "./MetroidvaniaDescript.vue?vue&type=script&setup=true&lang=js"
export * from "./MetroidvaniaDescript.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports